import React from "react"
import { innerContainer, inputContainer } from "../../personal.module.css"

export const CompleteUserDetails = ( { user } ) => {
  if ( !user ) return <span>Loading...</span>
  return (
    <>
      <div className={ innerContainer }>
        <div className={ inputContainer }>
          <p>First Name*</p>
          <p>{ user.firstName }</p>
        </div>
        <div className={ inputContainer }>
          <p>Last Name*</p>
          <p>{ user.secondName }</p>
        </div>
      </div>
      <div className={ innerContainer }>
        <div className={ inputContainer }>
          <p>Email*</p>
          <p>{ user.email } </p>
          <p name="error-email" />
        </div>
      </div>
      <div className={ innerContainer }>
        <div className={ inputContainer }>
          <p>Phone Number*</p>
          <p>{ user.phoneNumber }</p>
        </div>
      </div>
    </>
  )
}

export default CompleteUserDetails